import { BillingService } from '@qdrant/qdrant-cloud-public-api/billing/v1';
import {
  getBillingAccountParent,
  listBillingAccountChildren,
  listCreditContracts,
  listDiscounts,
  listInvoices,
} from '@qdrant/qdrant-cloud-public-api/billing/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';

export const BillingServices = createServiceQueries(BillingService, {
  getBillingAccountParentQuery: (params) =>
    queryOptions(getBillingAccountParent, params, {
      transport,
      select: (data) => data.parentAccountId,
    }),
  listBillingAccountChildrenQuery: (params) =>
    queryOptions(listBillingAccountChildren, params, { transport, select: (data) => data.childAccountIds }),
  listCreditContractsQuery: (params) =>
    queryOptions(listCreditContracts, params, {
      transport,
      timeoutMs: 30_000,
      select: (data) => data,
    }),
  listDiscountsQuery: (params) => queryOptions(listDiscounts, params, { transport, select: (data) => data.items }),
  listInvoicesQuery: (params) => queryOptions(listInvoices, params, { transport, select: (data) => data.items }),
});
